import { render } from "./CreateTypeChambre.vue?vue&type=template&id=74c7acd2"
import script from "./CreateTypeChambre.vue?vue&type=script&lang=js"
export * from "./CreateTypeChambre.vue?vue&type=script&lang=js"

import "./CreateTypeChambre.vue?vue&type=style&index=0&id=74c7acd2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__